import { produce } from 'immer';
import { assetUtils } from '@zen/common-utils';
import { ZenJsUtils } from '@zen/common-app-parts';
import * as OrderConverter from '../../../utils/OrderConverter';

const { getAssetFullId } = assetUtils;

export const ACTIONS = {
  SET_BASE_REQUESTED: 'SET_BASE_REQUESTED',
  SET_QUOTE_REQUESTED: 'SET_QUOTE_REQUESTED',
  UPDATE_ASSETS_REQUESTED: 'UPDATE_ASSETS_REQUESTED',
  SEARCH: {
    REQUESTED: 'SEARCH_REQUESTED',
    SUCCEEDED: 'SEARCH_SUCCEEDED',
    FAILED: 'SEARCH_FAILED',
  },
  RESET: {
    REQUESTED: 'RESET_REQUESTED',
  },
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case ACTIONS.SET_BASE_REQUESTED:
      setEditAsset(draft, action.payload, 'base');
      break;
    case ACTIONS.SET_QUOTE_REQUESTED:
      setEditAsset(draft, action.payload, 'quote');
      break;
    case ACTIONS.UPDATE_ASSETS_REQUESTED:
      draft.base = action.payload.base;
      draft.quote = action.payload.quote;
      setEditAsset(draft, action.payload.base, 'base');
      setEditAsset(draft, action.payload.quote, 'quote');
      break;
    case ACTIONS.SEARCH.REQUESTED:
      draft.searching = true;
      draft.orders = {};
      break;
    case ACTIONS.SEARCH.SUCCEEDED:
      draft.orders = OrderConverter.ordersToBuysAndSells({
        base: getAssetFullId(draft.base),
        orders: action.payload.map((order) => ({
          ...order,
          pending: !!order.pending, // convert to boolean
        })),
      });
      draft.searching = false;
      break;
    case ACTIONS.SEARCH.FAILED:
      // TODO set error
      draft.searching = false;
      break;
    case ACTIONS.RESET.REQUESTED:
      draft.edit.base.value = '';
      draft.edit.base.valid = undefined;
      draft.edit.quote.value = '';
      draft.edit.quote.valid = undefined;
      draft.base = '';
      draft.quote = '';
      draft.searching = false;
      draft.orders = {};
      break;
    default:
      throw new Error(`Unhandled action type ${action.type}`);
  }
});

export default reducer;

/**
 * @param {*} draft
 * @param {string} asset
 * @param {('base'|'quote')} prop
 */
function setEditAsset(draft, asset, prop) {
  const value = (asset || '').trim().toLowerCase();
  draft.edit[prop].value = value;
  draft.edit[prop].valid = value ? ZenJsUtils.validateAsset(value) : undefined;
}
